export const AUTH_REQUEST = "AUTH_REQUEST";
export const GOOGLE_AUTH_REQUEST = "GOOGLE_AUTH_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_RESET_PASSWORD_REQUEST = "AUTH_RESET_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";

export const REGISTER_REQUEST = "REGISTER_REQUEST";

export const TOGGLE_AUTH_POPUP = "TOGGLE_AUTH_POPUP"
export const REPLACE_AUTH_ACTIVE_COMPONENT = "REPLACE_AUTH_ACTIVE_COMPONENT"

export const UPDATE_AUTH_CUSTOMER_INFO = "UPDATE_AUTH_CUSTOMER_INFO"
export const LOGOUT = "LOGOUT"

export const REFRESH_TOKEN = "REFRESH_TOKEN"

export const SEND_VERIFICATION_CODE = "SEND_VERIFICATION_CODE"

export const CHECK_VERIFICATION_CODE = "CHECK_VERIFICATION_CODE"

export const EDIT_MATCH_PERCENTAGE = "EDIT_MATCH_PERCENTAGE"